import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";

export default function MessagesTab() {
    const [items, setItems] = useState(null);

    const load = useCallback(() => {
        api.get("/admin/messages").then((r) => setItems(r.data)).catch(() => toast.error("Failed to load messages"));
    }, []);
    useEffect(() => { load(); }, [load]);

    const remove = async (id) => {
        await api.delete(`/admin/messages/${id}`);
        toast.success("Deleted");
        load();
    };

    if (!items) return <p className="text-sm text-neutral-500">Loading…</p>;

    return (
        <div data-testid="messages-tab">
            <div className="mb-6 flex items-center justify-between">
                <h2 className="font-display text-3xl">CONTACT ENQUIRIES</h2>
                <button onClick={load} data-testid="messages-refresh-btn" className="border border-neutral-300 px-4 py-2 text-xs font-semibold uppercase tracking-wider hover:border-[#D60024] hover:text-[#D60024]">
                    Refresh
                </button>
            </div>
            <div className="space-y-3">
                {items.length === 0 && <p className="border border-neutral-200 bg-white px-4 py-8 text-center text-sm text-neutral-400">No enquiries yet.</p>}
                {items.map((m, i) => (
                    <div key={m.id} className="border border-neutral-200 bg-white p-5" data-testid={`message-row-${i}`}>
                        <div className="flex flex-wrap items-baseline justify-between gap-2">
                            <p className="text-sm font-semibold">
                                {m.name} <span className="font-normal text-neutral-500">{m.company && `— ${m.company}`}</span>
                            </p>
                            <span className="text-xs text-neutral-400">{m.created_at ? new Date(m.created_at).toLocaleString() : ""}</span>
                        </div>
                        <p className="mt-1 text-xs text-neutral-500">
                            {m.email} {m.phone && `· ${m.phone}`} {m.topic && `· ${m.topic}`}
                        </p>
                        <p className="mt-3 whitespace-pre-wrap text-sm text-neutral-700">{m.message}</p>
                        <div className="mt-3 flex gap-4">
                            <a href={`mailto:${m.email}`} className="text-xs font-semibold uppercase tracking-wider text-[#D60024]">Reply</a>
                            <button onClick={() => remove(m.id)} data-testid={`message-delete-${i}`} className="text-xs font-semibold uppercase tracking-wider text-neutral-400 hover:text-[#D60024]">Delete</button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
